/**
 * Guest discovery context taxonomy (#1920/#1921) — frontend mirror.
 *
 * Mirrors `backend/src/constants/scenarioContexts.js` exactly (same seven
 * slugs, same display labels, frozen mapping of record: `docs/design/briefs/
 * mobile-guest-journey-2026-07/taxonomy-review-v2-2026-08-06.html`).
 *
 * NOT a shared import: the frontend (Vite) and backend (Node) source trees
 * in this monorepo are separately bundled, so there is no import path
 * between them — the backend constants file's own header notes the same
 * constraint one level down (migrations can't import app code either).
 * Kept in sync by `frontend/src/constants/__tests__/scenarioContexts.sync.test.js`,
 * which reads the backend file's source as text and asserts the two lists
 * match, rather than a shared import.
 *
 * Used to validate a `:contextSlug` route param (`GuestDiscoveryShortlistPage`)
 * before the API round-trip, and to render the J3 header label/icon. The
 * canonical per-context COUNT always comes from the API
 * (`/api/demo/discovery/contexts`), never from this file — this file has no
 * count field on purpose.
 */
export const SCENARIO_CONTEXTS = [
  'at_work',
  'serving_people',
  'leading_people',
  'my_own_career',
  'school_community',
  'personal',
  'speaking_up',
];

export const SCENARIO_CONTEXT_LABELS = {
  at_work: 'At work',
  serving_people: 'Serving people',
  leading_people: 'Leading people',
  my_own_career: 'My own career',
  school_community: 'School & community',
  personal: 'Personal',
  speaking_up: 'Speaking up',
};

/**
 * Guest front-door curation (#2098 call 6) — mirrors
 * `backend/src/constants/scenarioContexts.js`'s `GUEST_EXCLUDED_CONTEXTS`
 * exactly (kept in sync by `scenarioContexts.sync.test.js`, same mechanism
 * as `SCENARIO_CONTEXTS`/`SCENARIO_CONTEXT_LABELS` above — no shared import
 * across the frontend/backend boundary). Used only to give a guest who
 * navigates directly to `/discover/personal` or `/discover/school_community`
 * the "we don't recognise that context" message instead of a misleading
 * "no scenarios ready yet" empty state — the API itself is the enforcement
 * point (`GET /discovery/context/:slug/shortlist` 404s these slugs).
 */
export const GUEST_EXCLUDED_CONTEXTS = ['personal', 'school_community'];
